
<template>
  <page>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl3 lg6 xs6 v-if="!hasRiskTxtRef">
                        <!-- if has no received risk txt ref -->
                        <v-text-field v-model="filters.stdRiskTxtRef" :label="labels.stdRiskTxtRef" :error-messages="errors.collect('stdRiskTxtRef')" data-vv-name="stdRiskTxtRef" :data-vv-as="labels.stdRiskTxtRef" v-validate="'name|max:3'"></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field v-model="filters.stdItemTxtRef" :label="labels.stdItemTxtRef" :error-messages="errors.collect('stdItemTxtRef')" data-vv-name="stdItemTxtRef" :data-vv-as="labels.stdItemTxtRef" v-validate="'name|max:3'"></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field v-model="filters.stdItemTxtLn" :label="labels.stdItemTxtLn" :error-messages="errors.collect('stdItemTxtLn')" data-vv-name="stdItemTxtLn" :data-vv-as="labels.stdItemTxtLn" v-validate="'name|max:1000'"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNewStdItemTxt()" v-if="!loading">
            New Standard Item Text<v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
          <template v-slot:item="row"><tr>
            <td>{{ row.item.stdItemTxtRef }}</td>
            <td class="text-xs-left">{{ row.item.stdItemTxtLn }}</td>
            <td class="table-action-header">
              <table-action :rowData="row" review @review="doStdItemTxtReview(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
            </td></tr>
          </template>
        </v-data-table>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Standard Item Text? {{deleteStdItemTxt}}
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'

export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Item Text Ref', align: 'left', value: 'stdItemTxtRef' },
        { text: 'Item Text Line', value: 'stdItemTxtLn' },
        TableConst.tableActionHeader
      ],
      labels: {
        stdRiskTxtRef: 'Standard Risk Text Ref',
        stdItemTxtRef: 'Standard Item Text Ref',
        stdItemTxtLn: 'Standard Item Text Line'
      },
      filters: {
        stdRiskTxtRef: undefined,
        stdItemTxtRef: undefined,
        stdItemTxtLn: undefined
      },
      totalItems: 0,
      selectedStdItemTxtRef: undefined,
      deleteStdItemTxt: '',
      loading: false,
      promptRemove: false,
      hasRiskTxtRef: false,
      stdRiskTxtRef: '',
      riskTxtRef: '',
      riskTxtLn: '',
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  computed: {
    stdItemTxtRefMenu() {
      return this.$store.state.StdItemTxtParam.menu
    },
    stditemtxt() {
      return this.$route.params.stditemtxt
    },
    stdriskln() {
      return this.$route.params.stdriskln
    }
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.stdItemTxtRefMenu.getStdRiskItemTxtList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((stdItemTxtdatamap) => {
                const convertList = {
                  createdBy: stdItemTxtdatamap.createdBy,
                  createdDate: stdItemTxtdatamap.createdDate,
                  createdName: stdItemTxtdatamap.createdName,
                  defThisItemTxt: stdItemTxtdatamap.defThisItemTxt,
                  modifiedBy: stdItemTxtdatamap.modifiedBy,
                  modifiedDate: stdItemTxtdatamap.modifiedDate,
                  modifiedName: stdItemTxtdatamap.modifiedName,
                  stdItemOptTxtLn: stdItemTxtdatamap.stdItemOptTxtLn,
                  stdItemTxtLn: stdItemTxtdatamap.stdItemTxtLn,
                  stdItemTxtRef: stdItemTxtdatamap.stdItemTxtRef,
                  stdRiskTxtRef: stdItemTxtdatamap.stdRiskTxtRef,
                  stdRiskTxtLn: stdItemTxtdatamap.stdRiskTxtLn
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.stdItemTxtRef = null
      this.filters.stdItemTxtLn = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doStdItemTxtReview(conlist) {
      this.$router.push({ name: 'stdItemTxtReview', params: { conlist: conlist } })
    },
    doNewStdItemTxt(riskTxtRef, riskTxtLn) {
      this.$router.push({ name: 'stdItemTxtReview', params: { stdriskitemtxt: 'new', riskTxtRef: this.riskTxtRef, riskTxtLn: this.riskTxtLn } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedStdItemTxtRef = data
        this.deleteStdItemTxt = data.stdItemTxtRef
      }
    },
    async doRemove() {
      const apiURI = this.stdItemTxtRefMenu.deleteStdRiskItemTxt
      if (apiURI) {
        const expand = this.selectedStdItemTxtRef
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  created() {
    if (this.stditemtxt) {
      this.hasRiskTxtRef = true
      this.stdRiskTxtRef = this.stditemtxt
      this.filters.stdRiskTxtRef = this.stditemtxt
      this.riskTxtRef = this.stditemtxt
      this.riskTxtLn = this.stdriskln
    } else {
      this.hasRiskTxtRef = false
      this.stdRiskTxtRef = undefined
    }
  },
  mounted() {
    // determine 2 situation, one with stdRiskTxtRef and one without
    // if has stdRiskTxtRef sent, apply filter on it
    // else, return all item text.
    if (this.hasRiskTxtRef) {
      this.doFilters(true)
    } else {
      this.doInit(true)
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
